/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Score
 */
export interface Score {
  /**
   *
   * @type {string}
   * @memberof Score
   */
  endedAt: string
  /**
   *
   * @type {number}
   * @memberof Score
   */
  score: number
}

/**
 * Check if a given object implements the Score interface.
 */
export function instanceOfScore(value: object): boolean {
  if (!('endedAt' in value)) return false
  if (!('score' in value)) return false
  return true
}

export function ScoreFromJSON(json: any): Score {
  return ScoreFromJSONTyped(json, false)
}

export function ScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): Score {
  if (json == null) {
    return json
  }
  return {
    endedAt: json['endedAt'],
    score: json['score'],
  }
}

export function ScoreToJSON(value?: Score | null): any {
  if (value == null) {
    return value
  }
  return {
    endedAt: value['endedAt'],
    score: value['score'],
  }
}
